import { h } from 'preact';
export const PlusSquare = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", ry: "2" }),
        h("line", { x1: "12", y1: "8", x2: "12", y2: "16" }),
        h("line", { x1: "8", y1: "12", x2: "16", y2: "12" })));
};
//# sourceMappingURL=plus-square.js.map